import { render } from "./NavbarIdiomas.vue?vue&type=template&id=2257fedc"
import script from "./NavbarIdiomas.vue?vue&type=script&lang=js"
export * from "./NavbarIdiomas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__